<template>
    <div>
        <section class="content">
        <div class="container-fluid">

        <div class="row clearfix">

            <div class="bg-light-green" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku">
                    <div class="col-md-3 searching">
                        <span class="h_page">Laporan Pembayaran</span> <br> <br>
                    </div>
                    <div class="col-md-6">

                    </div>
                    <div class="col-md-3 searching">
                        <div class="input-group">
                            <span class="input-group-btn">
                                <button type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons">add</i></button>
                            </span>
                            <input type="text" class="form-control" placeholder="Cari data" id="caridata" >
                        </div> <br>
                    </div>
                </div>
            </div>


            <div class="col-xs-12 card">
        <!-- ============================================================ MULAI ======================================================================== -->
                <br>
                <div class="row">
                    <div class="col-sm-2"></div>
                    <div class="col-sm-10">
                        <div class="form-group">
                            <input type="radio" name="gender" id="radio1" class="with-gap">
                            <label for="radio1">Laporan Penerimaan PBB</label>
                            <br>
                            <input type="radio" name="gender" id="radio2" class="with-gap">
                            <label for="radio2">Laporan Detil PB Kecamatan</label>
                            <br>
                            <input type="radio" name="gender" id="radio3" class="with-gap">
                            <label for="radio3">Laporan Detil Penerimaan</label>
                            <br>
                            <input type="radio" name="gender" id="radio4" class="with-gap">
                            <label for="radio4">Laporan Detil Rekap Penerimaan</label>
                            <br>
                            <input type="radio" name="gender" id="radio5" class="with-gap">
                            <label for="radio5">Laporan Harian Penerimaan</label>
                            <br>
                            <input type="radio" name="gender" id="radio6" class="with-gap">
                            <label for="radio6">Laporan Harian Penerimaan Per Bank</label>
                            <br>
                            <input type="radio" name="gender" id="radio7" class="with-gap">
                            <label for="radio7">Laporan Rekap Penerimaan Per Bank</label>
                            <br>
                            <input type="radio" name="gender" id="radio8" class="with-gap">
                            <label for="radio8">Laporan Detil Penerimaan Per Bank</label>
                            <br>
                            <input type="radio" name="gender" id="radio9" class="with-gap">
                            <label for="radio9">Laporan Data Pembayaran Per Kelurahan</label>
                            <br>
                            <input type="radio" name="gender" id="radio10" class="with-gap">
                            <label for="radio10">Laporan Data Pembayaran Lengkap Per Kelurahan</label>
                            <br>
                            <input type="radio" name="gender" id="radio11" class="with-gap">
                            <label for="radio11">Laporan Data Pembayaran Lengkap Per Kelurahan(Tanggal klik)</label>
                        </div>
                    </div>
                </div>
                <br> <hr>
                <div class="row">
                    <div class="col-sm-2"></div>
                    <div class="col-sm-10">
                        <button type="button" class="btn bg-light-blue btn-sm waves-effect"><i class="material-icons">print</i>Cetak</button>
                    </div>
                </div>
                <br>
        <!-- ============================================================ MULAI ======================================================================== -->
            </div>

        </div>

        </div>
      </section>



    </div>
</template>


<script>

const ADD_URL = URL_APP+'api/v1/kecamatan/';


export default {
  name: "monev_kabupaten",
  data() {
    return {

    };
  },

// =============================================================== METHODS =========================================================================
  methods : {


  },
// =============================================================== METHODS =========================================================================

  mounted() {
    localStorage.sidemenu = 'bhumie';
  },
};
</script>
